import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentChartDropdownComponent } from './instrument-chart-dropdown.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';



@NgModule({
  declarations: [
    InstrumentChartDropdownComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    InstrumentChartDropdownComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class InstrumentChartDropdownModule { }
